import { Controller } from "@hotwired/stimulus"
import Handlebars from "handlebars"
import BaseGrid, { html } from "../utils/base_grid"

// Pre-compile templates
const actionButtonsTemplate = Handlebars.compile(`
  <a href="{{viewUrl}}" class="btn btn-secondary btn-sm" data-bs-title="{{viewLabel}}" data-bs-toggle="tooltip" data-turbo-frame="_top"><i class="fa-solid fa-eye"></i></a>
  <a href="{{editUrl}}" class="btn btn-secondary btn-sm" data-bs-title="{{editLabel}}" data-bs-toggle="tooltip" data-turbo-frame="_top"><i class="fa-solid fa-pen"></i></a>
`)

const languageBadgeTemplate = Handlebars.compile(`
  <span class="badge badge-{{language}}">{{language}}</span>
`)

const codeTemplate = Handlebars.compile(`
  <code>{{code}}</code>
`)

export default class extends Controller {
  static values = { url: String, translations: Object }
  static targets = ["container", "skeleton"]

  connect() {
    const t = this.translationsValue || {}
    
    this.baseGrid = new BaseGrid(this, {
      limit: 20,
      columns: [
        { name: t.name || "Name", id: "name" },
        { 
          name: t.folder || "Folder", 
          id: "folder_name",
          formatter: (cell) => html(codeTemplate({ code: cell }))
        },
        { 
          name: t.language || "Language", 
          id: "language",
          formatter: (cell) => html(languageBadgeTemplate({ language: cell.toUpperCase() }))
        },
        { name: t.contents || "Contents", id: "contents_count" },
        { name: "ID", id: "id", hidden: true },
        { name: "ViewURL", id: "view_url", hidden: true },
        { name: "EditURL", id: "edit_url", hidden: true },
        { 
          name: t.actions || "Actions",
          sort: false,
          formatter: (cell, row) => {
             return html(actionButtonsTemplate({ 
               viewUrl: row.cells[5].data, 
               editUrl: row.cells[6].data,
               viewLabel: t.view || "View",
               editLabel: t.edit || "Edit"
             })) 
          }
        }
      ],
      mapData: (item) => [
        item.name, 
        item.folder_name, 
        item.language, 
        item.contents_count,
        item.id, 
        item.view_url,
        item.edit_url
      ]
    })
    
    this.grid = this.baseGrid.create()
  }
  
  disconnect() {
    this.baseGrid.destroy()
  }
}
